import './styles.css';
import 'core-js/stable';

import { Provider } from 'jotai';
import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import App from '@/components/app/App';
import Dashboard from '@/components/dashboard/Dashboard';
import LiveCollaborativeError from '@/components/live-collaborative/live-collaborative-error/LiveCollaborativeError';
import { registerSW } from '@/registerSW';
import { AuthGuard } from '@/routes/auth/AuthGuard';
import LoginPage from '@/routes/auth/Login';
import Root from '@/routes/root/Root';
import { store } from '@/store';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <LiveCollaborativeError />,
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        element: <AuthGuard />,
        children: [
          {
            index: true,
            element: <Dashboard />,
          },
          {
            path: 'project/:projectId',
            element: <App />,
          },
          {
            path: 'live',
            lazy: async () => {
              const { default: Component } = await import(
                '@/components/live-collaborative/LiveCollaborative'
              );
              return { Component };
            },
            errorElement: <LiveCollaborativeError />,
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);

const root = createRoot(document.getElementById('app')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

if (import.meta.env.MODE === 'production') {
  registerSW();
}
